export default function humanFileSize(bytes, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  let dividedBytes = bytes;
  do {
    dividedBytes /= thresh;
    u += 1;
  } while (Math.round(Math.abs(dividedBytes) * r) / r >= thresh && u < units.length - 1);

  return `${dividedBytes.toFixed(dp)} ${units[u]}`;
}
